export default class DtoOperationReferencial {
    constructor(obj) {
        this.code = obj.code.toString()
        this.id = obj.code
        this.name = obj.name
        this.nameWithCode = `${obj.name || ''} [${obj.code}]`
    }
}
